/**
 * @generated SignedSource<<0e161f484d39cb7060e7fafe9b975774>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type FlagCell$data = {
  readonly flag: {
    readonly isFlagged: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "FlagCell";
};
export type FlagCell$key = {
  readonly " $data"?: FlagCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"FlagCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "FlagCell",
  "selections": [
    {
      "concreteType": "JiraFlag",
      "kind": "LinkedField",
      "name": "flag",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isFlagged"
        }
      ]
    }
  ],
  "type": "JiraFlagField"
};

(node as any).hash = "a132d27c76c2fbd37572315422c76c0c";

export default node;
